import { c as _c } from "react/compiler-runtime";
import { Box, Stack } from "@mui-wrapper";
import { LIMIT_UNIT_LABEL } from "@src/constants/subscription-constants";
import { ExclamationMarkCircleFillIcon, Text } from "@flat-ui";
import { DEFAULT_INPUT_FONT_SIZE, DEFAULT_TEXT_FONT_WEIGHT } from "@styles/common-styles";
import { NumberUtils } from "@stellar/utils";
import { hasExceededQuota } from "@hooks/subscription/use-usage-metrics";
/** Details of a subscription limit */
export function SubscriptionLimit(t0) {
  const $ = _c(20);
  const {
    limit,
    actionComponent
  } = t0;
  const limitNameDisplay = LIMIT_UNIT_LABEL[limit.identifier];
  let t1;
  if ($[0] !== limit) {
    t1 = hasExceededQuota(limit);
    $[0] = limit;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const shouldShowWarning = t1;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      justifyContent: "space-between",
      alignItems: "center",
      width: "100%"
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      gap: 1,
      display: "flex",
      alignItems: "center"
    };
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== shouldShowWarning) {
    t4 = shouldShowWarning && <ExclamationMarkCircleFillIcon sx={{
      color: "warning.main",
      width: "20px",
      height: "20px"
    }} />;
    $[4] = shouldShowWarning;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== limit.current) {
    t5 = NumberUtils.formatNumberWithSpaces(limit.current ?? 0);
    $[6] = limit.current;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  const t6 = `${t5}`;
  let t7;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = {
      fontSize: DEFAULT_INPUT_FONT_SIZE,
      fontWeight: DEFAULT_TEXT_FONT_WEIGHT,
      lineHeight: "20px"
    };
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] !== limit.limit) {
    t8 = NumberUtils.formatNumberWithSpaces(limit.limit);
    $[9] = limit.limit;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  const t9 = `/ ${t8} ${limitNameDisplay}`;
  let t10;
  if ($[11] !== t9) {
    t10 = <Box component="span" sx={t7}>{t9}</Box>;
    $[11] = t9;
    $[12] = t10;
  } else {
    t10 = $[12];
  }
  let t11;
  if ($[13] !== t10 || $[14] !== t4 || $[15] !== t6) {
    t11 = <Text variant="heading20" sx={t3}>{t4}{t6}{t10}</Text>;
    $[13] = t10;
    $[14] = t4;
    $[15] = t6;
    $[16] = t11;
  } else {
    t11 = $[16];
  }
  let t12;
  if ($[17] !== actionComponent || $[18] !== t11) {
    t12 = <Stack direction="row" sx={t2}>{t11}{actionComponent}</Stack>;
    $[17] = actionComponent;
    $[18] = t11;
    $[19] = t12;
  } else {
    t12 = $[19];
  }
  return t12;
}